// $(document).ready(function() {

//   // 🔽 Click on the label area to show/hide options
//   $('.rname_firt_option').on('click', function() {
//     $('.rammne_value').toggle(); // show or hide options
//   });

//   // 🖱️ Click on any option
//   $('.rammne_value').on('click', function() {

//        var selectedOption = $(this).data('option');
//        var $select = $('select[name="options[Ramme]"]');
//        $('.rname_firt_option label').text(selectedOption);

//        var $matchedOption = $select.find('option[value="' + selectedOption + '"]');

//         if ($matchedOption.length) {

//             var variantId = $matchedOption.data('variant-id');
//             $select.val(selectedOption).trigger('change');
//             $('input[name="id"][ref="variantId"]').val(variantId);

//         } 
//         else
//         {
//             console.warn('No matching option found for:', selectedOption);
//         }
//     $('.rammne_value').hide();
//   });

// });




$(document).ready(function () {

  $('.rname_firt_option').on('click', function () {
    $('.rammne_value').toggle();
  });

  $('.rammne_value').on('click', function () {
    var selectedOption = $(this).data('option');
    var $select = $('select[name="options[Ramme]"]');
    var $matchedOption = $select.find('option[value="' + selectedOption + '"]');

    if ($matchedOption.length) {
      $select.val(selectedOption).trigger('change');
      $('.rname_firt_option label').text(selectedOption);

      var variantUrl = $matchedOption.data('connected-product-url');
      var variantId = $matchedOption.data('variant-id');

      // ✅ Force page reload to correct variant
      if (variantUrl && variantUrl !== '') {
        window.location.href = variantUrl; // go to variant URL directly
      } else if (variantId) {
        var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
        window.location.href = newUrl; // open new variant URL
      }
    }

    $('.rammne_value').hide();
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.ramme_option').length) {
      $('.rammne_value').hide();
    }
  });

});

